<div [ngClass]="theme.getThemeClass()" class="main-container card"><!-- class="bg-light" -->
    <h2>{{"apiManagement" | translate}}</h2>
  <div class="api-form">
    <label class="label-spacer">{{ "entity" | translate }}:</label>
      <select
        name="selectedEntities"
        [(ngModel)]="selectedEntity"
        class="form-control"
        (change)="setEntityValues()"
      >
        <option [ngValue]="undefined">{{ 'entity' | translate }}</option>
        @for (entity of allEntities; track entity.id ?? entity.name) {
          <option [ngValue]="entity">{{ entity.name }}</option>
        }
      </select>
        @if (entityKey) {
            <label class="label-spacer">
                <span>{{"key" | translate}}:</span> 
            </label>
            <input class="form-control" type="password" disabled name="entityKey" [(ngModel)]="entityKey"/>
            <button class="btn" [ngClass]="theme.getThemeClass()" (click)="resendKeyToEmail()">{{"resend" | translate}}</button>
            <button class="btn" [ngClass]="theme.getThemeClass()" (click)="copyToClipboard(entityKey)">{{"copyToClipBoard" | translate}}</button>
        }
        
        <label class="label-spacer">
            <span>{{"email" | translate}}:</span> 
        </label>
        <input  class="form-control" disabled name="entityEmail" [(ngModel)]="entityEmail"/>
        <label class="label-spacer">
            <span>{{"phoneNumber" | translate}}:</span> 
        </label>
        <input class="form-control" disabled name="entityPhone" [(ngModel)]="entityPhone"/>
        
        <!-- If we want to add an sms option in the futur   -->
        <!-- <label class="input-checkbox">Email <input [(ngModel)]="isEmailChecked" type="checkbox"/></label>
        <label class="input-checkbox">SMS <input [(ngModel)]="isSmsChecked" type="checkbox"/></label> -->
        <!--                                                -->
        <button class="btn" [ngClass]="[theme.getThemeClass(), selectedEntity ? '' : 'disabled']" type="button" (click)="generateAction()" >{{"generate" | translate}}</button>
    </div>
</div>
